import * as tslib_1 from "tslib";
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import StandardMenu from '../../../Dropdown/Preset/StandardMenu';
import { covertToFoldersWithSubfolders } from '../../../utils/folders';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import withCurrentSubfolder from '../../_hocs/withCurrentSubfolder';
import withGallections from '../../_hocs/withGallections';
import { areGallectionContentsManageable } from '../../helpers';
import { getAllGallections } from '../../selectors';
import * as s from './GallectionListMenu.scss';
var enhance = compose(withCurrentGallection, withCurrentSubfolder, withGallections, withTranslation(), connectMediaStore(function (state) { return ({ allGallections: getAllGallections(state) }); }));
var GallectionListMenu = /** @class */ (function (_super) {
    tslib_1.__extends(GallectionListMenu, _super);
    function GallectionListMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GallectionListMenu.prototype.render = function () {
        var _a = this.props, allGallections = _a.allGallections, currentFolderId = _a.currentFolderId, currentSubfolderId = _a.currentSubfolderId, onlyTopLevelFolders = _a.onlyTopLevelFolders, disableFolderIds = _a.disableFolderIds;
        var currentGallectionFolderId = currentSubfolderId || currentFolderId;
        var shouldShowMenuItemDisabled = function (folder) {
            return folder.folderId === currentGallectionFolderId ||
                !areGallectionContentsManageable(folder) ||
                (disableFolderIds || []).includes(folder.folderId);
        };
        var menuItems = [];
        var foldersWithSubfolders = covertToFoldersWithSubfolders(allGallections);
        foldersWithSubfolders.forEach(function (_a) {
            var folder = _a.folder, subfolders = _a.subfolders;
            menuItems.push({
                value: folder.folderId,
                label: folder.name,
                disabled: shouldShowMenuItemDisabled(folder),
            });
            if (onlyTopLevelFolders) {
                return;
            }
            menuItems.push.apply(menuItems, subfolders.map(function (subfolder) { return ({
                value: subfolder.folderId,
                label: subfolder.name,
                className: s['subfolder'],
                disabled: shouldShowMenuItemDisabled(subfolder),
            }); }));
        });
        return (React.createElement(StandardMenu, { lightText: true, label: this.props.t('mediapopup.selectFolder'), className: classnames(s['root'], this.props.className), items: menuItems, onSelect: this.props.onSelect }));
    };
    return GallectionListMenu;
}(React.Component));
export default enhance(GallectionListMenu);
//# sourceMappingURL=GallectionListMenu.connected.js.map